import React from "react";
import { Label } from "@logora/parliament.ui.label";
import cx from "classnames";
import styles from "./VoteBox.module.scss";

interface VoteBoxProps {
	/** Date */
	date: string;
	/** Main text  */
	mainText: string;
	/** Status of the voted item */
	status: string;
	/** Which item the vote is on */
	type?: string;
	/** What is the current vote */
	votePosition?: string;
	/** Highlighting status of the voted item with a label for design purposes */
	statusHighlighted?: boolean;
	/** Extra className */
	className?: string;
	/** UID */
	voteUid: string;
}

let colorVariants = {
	success: ["pour", "adopté"],
	cancel: ["contre", "rejeté"],
	pending: ["modéré"],
	info: ["en discussion"],
	neutral: ["tombé", "non soutenu", "retiré", "abstention"],
	default: [],
};

export const VoteBox: React.FC<VoteBoxProps> = ({
	date,
	mainText,
	status,
	type,
	votePosition,
	statusHighlighted = false,
	className,
	voteUid
}) => {
	return (
		<a 
			className={`${className} ${styles.voteBoxContainer}`}
			href={`/#/parliament/scrutins/${voteUid}`}
		>
			<div className={styles.voteBoxHeader}>
				{votePosition && (
					<Label
						className={styles.votePositionLabel}
						text={votePosition}
						colorType={votePosition}
						variantsObject={colorVariants}
					/>
				)}
				{type &&
					<span className={styles.voteBoxType}>{type}</span>
				}
				<span className={styles.voteBoxDate}>
					Réalisé le{" "}
					{new Date(date).toLocaleDateString("fr-FR", {
						day: "2-digit",
						month: "long",
						year: "numeric",
					})}
				</span>
			</div>
			<div className={styles.voteBoxContent}>
				{mainText}
			</div>
			<div className={styles.voteBoxStatusContainer}>
				{statusHighlighted ? (
					<Label
						text={status}
						className={styles.voteBoxStatus}
						colorType={status}
						variantsObject={colorVariants}
					/>
				) : (
					<>{status}</>
				)}
			</div>
		</a>
	);
};
